import * as React from 'react';
import { Col, Container, Row, Image } from 'react-bootstrap';


export default function Mission() {
    return (
        <>
            <Container className='mission'>
                <h1>Who we are</h1>
                <Row>
                    <Col className='d-none d-lg-block ' sm={3}></Col>
                    <Col>
                        <b>
                            EarsOnly builds on the combined expertise of Dopple and Reduson in wearable technology and Custom-Fit hearing protection.
                        </b>
                        <br /><br />
                        Our mission is to protect hearing without compromising comfort, performance, or usability. We specialize in Custom-Fit hearing protection solutions designed to perform in the most demanding environments.
                        <br /><br />
                        EarsOnly <b>Protect</b> stands at the core of our portfolio, a premium hearing protection solution that combines advanced engineering with user-centric design. Alongside Protect, we offer <b>Redux</b>, a wide range of custom-fit passive products designed for use across various environments.
                        <br /><br />

                        Together, our solutions deliver trusted hearing protection, engineered for real-world performance, protecting your ears.
                        All day. Every day.
                    </Col>
                    <Col className='d-none d-lg-block ' sm={3}></Col>
                </Row>
                <Row sm={1} md={3} className='mission-logos'>
                    <Col >
                        <a href='https://dopple.nl/' target='_blank'>
                            <Image src="/images/logos/DoppleLogo.png" className='mission-logo' />
                        </a>
                    </Col>
                    <Col >
                        <a href='/' target='_blank'>
                            <Image src="/images/logos/EarsOnlyLogo.png" className='mission-logo' />
                        </a>
                    </Col>
                    <Col >
                        <a href='https://reduson.nl/' target='_blank'>
                            <Image src="/images/logos/RedusonLogo.png" className='mission-logo' />
                        </a>
                    </Col>
                </Row>
            </Container>
        </>
    )
};
